import React, { useState } from "react";
import "../Styles/login.css";

const API_BASE_URL = "";

const Login = () => {
  // "login" = Login page, "forgot" = Forgot Password page
  const [view, setView] = useState("login");

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  // ---- CHANGED: status/error messaging for both forms ----
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);

  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotError, setForgotError] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ---- CHANGED: real login API call ----
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoginLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Login failed");
      }

      // Store minimal admin info so the dashboard knows someone is logged in.
      localStorage.setItem("vnk_admin", JSON.stringify(data.admin));
      window.location.href = "/dashboard";
    } catch (err) {
      setLoginError(err.message || "Login failed. Please try again.");
    } finally {
      setLoginLoading(false);
    }
  };

  // ---- CHANGED: real forgot-password API call ----
  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setForgotError("");
    setForgotMessage("");
    setForgotLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: forgotEmail }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to send reset link");
      }

      setForgotMessage(data.message || "A password reset link has been sent.");
      setForgotEmail("");
    } catch (err) {
      setForgotError(err.message || "Failed to send reset link. Please try again.");
    } finally {
      setForgotLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="login-left">
        <div className="login-logo">
        <img
            src="/assets/log-VHRD-logo.png"
            alt="Vanakkam HRD Logo"
            className="login-logo-img"
        />
        </div>

        <div className="login-illustration">
          <img src="/assets/log_img.png" alt="Vanakkam HRD" />
        </div>

        <div className="login-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="login-right">
        {view === "login" ? (
          <form className="login-form" onSubmit={handleLoginSubmit}>
            <h1 className="form-heading">Admin Login</h1>

            <p className="form-subheading">
              Enter your credentials to access the admin dashboard
            </p>

            <label className="form-label">User Email ID</label>

            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="Enter your Email ID"
              value={loginData.email}
              onChange={handleLoginChange}
              required
            />

            <label className="form-label">Password</label>

            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-input"
                placeholder="Enter your Password"
                value={loginData.password}
                onChange={handleLoginChange}
                required
              />
              <img
                src="/assets/log_eye.png"
                alt="Toggle password visibility"
                className="password-eye-icon"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            </div>

            {/* CHANGED: show login error, if any */}
            {loginError && <p className="form-error-msg">{loginError}</p>}

            <button
              type="button"
              className="link-btn forgot-link"
              onClick={() => {
                setView("forgot");
                setLoginError("");
              }}
            >
              Forgot Password?
            </button>

            <button type="submit" className="primary-btn" disabled={loginLoading}>
              {loginLoading ? "SIGNING IN..." : "SIGN IN"}
            </button>
          </form>
        ) : (
          <form className="login-form" onSubmit={handleForgotSubmit}>
            <h1 className="form-heading">Forgot Password?</h1>

            <p className="form-subheading">
              Enter your username and we'll send a reset link to the registered
              email.
            </p>

            <label className="form-label">User Email ID</label>

            <input
              type="email"
              name="forgotEmail"
              className="form-input"
              placeholder="Enter your Email ID"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />

            {/* CHANGED: show success/error message for forgot password */}
            {forgotMessage && <p className="form-success-msg">{forgotMessage}</p>}
            {forgotError && <p className="form-error-msg">{forgotError}</p>}

            <button
              type="button"
              className="link-btn back-link"
              onClick={() => {
                setView("login");
                setForgotMessage("");
                setForgotError("");
              }}
            >
              <div className="back-link-content">
            <img
                src="/assets/log-arrow.png"
                alt="Back"
                className="back-arrow"
            />
            <span>Back to Login</span>
            </div>
            </button>

            <button type="submit" className="primary-btn" disabled={forgotLoading}>
              {forgotLoading ? "SENDING..." : "Send Reset Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;